import { createAction } from 'redux-actions';
import axios from 'axios';
import UniversityService from '../../services/UniversityService';
export const FETCH_UNIVERSITY_PENDING = createAction('FETCH_UNIVERSITY_PENDING');
export const FETCH_UNIVERSITY_SUCCESS = createAction('FETCH_UNIVERSITY_SUCCESS');
export const FETCH_UNIVERSITY_ERROR = createAction('FETCH_UNIVERSITY_ERROR');


export const handleGetUniversity = () => {
    return async (dispatch, getState) => {
        const cancelToken = axios.CancelToken.source();
        dispatch(FETCH_UNIVERSITY_PENDING(cancelToken));
        try{
            const result = await UniversityService.retrieveUniversity({
              fields: 'id,name,slug,address,logo'
            });                 
            dispatch(FETCH_UNIVERSITY_SUCCESS(result.data));            
            localStorage.setItem('university',  JSON.stringify(result.data));
        }catch (error) {
          const statusCode = error.response ? error.response.status : 0;
          if (statusCode === 404) {
            dispatch(FETCH_UNIVERSITY_ERROR("University doens't exist."));
          }else{
            dispatch(FETCH_UNIVERSITY_ERROR("Try again later."));            
            console.log(error);
          }          
        }
    };
};

